var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3832_12923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5006 15.0006H14.7106L14.4306 14.7306C15.6306 13.3306 16.2506 11.4206 15.9106 9.39063C15.4406 6.61063 13.1206 4.39063 10.3206 4.05063C6.09063 3.53063 2.53063 7.09063 3.05063 11.3206C3.39063 14.1206 5.61063 16.4406 8.39063 16.9106C10.4206 17.2506 12.3306 16.6306 13.7306 15.4306L14.0006 15.7106V16.5006L18.2506 20.7506C18.6606 21.1606 19.3306 21.1606 19.7406 20.7506C20.1506 20.3406 20.1506 19.6706 19.7406 19.2606L15.5006 15.0006ZM9.50063 15.0006C7.01063 15.0006 5.00063 12.9906 5.00063 10.5006C5.00063 8.01063 7.01063 6.00063 9.50063 6.00063C11.9906 6.00063 14.0006 8.01063 14.0006 10.5006C14.0006 12.9906 11.9906 15.0006 9.50063 15.0006Z",
    className: "fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3832_12923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.03eaeba81139f5c5f81320005c084aa7.svg";
export { ForwardRef as ReactComponent };